"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("@0x/utils");
var web3_wrapper_1 = require("@0x/web3-wrapper");
// HACK (xianny): copied from asset-swapper, which will replace this package
var ONE_AMOUNT = new utils_1.BigNumber(1);
var ETHER_TOKEN_DECIMALS = 18;
exports.numberPercentageToEtherTokenAmountPercentage = function (percentage) {
    return web3_wrapper_1.Web3Wrapper.toBaseUnitAmount(ONE_AMOUNT, ETHER_TOKEN_DECIMALS).multipliedBy(percentage);
};
//# sourceMappingURL=number_percentage_to_ethertoken_amount_percentage.js.map